import { useState } from 'react';

import { Slide } from 'react-awesome-reveal';

import { useApp } from '../app-context';
import { ChatService } from '../services/ChatService'
import { TSPage } from '../components/commons';
import { ClaimSelector } from '../components/ClaimSelector';

import './ChooseClaimAppealPage.scss';

const ChooseClaimAppealPage = function ({ name, onBack, data, btn }) {
    const [state, dispatcher] = useApp();

    const [stateBusy, setStateBusy] = useState(false);
    const [stateSelectedClaim, setStateSelectedClaim] = useState(-1);

    const handleBack = (e) => {
        if (stateBusy) return;

        if (onBack)
            onBack(true, e);
    };

    const handleSelectClaim = (claimId, e) => {
        setStateSelectedClaim(claimId);
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (stateBusy || stateSelectedClaim <= 0) return;

        setStateBusy(true);

        let answer = {
            display: "תביעה " + stateSelectedClaim,
            value: stateSelectedClaim,
            id: btn?.id,
            field: btn?.field
        }

        ChatService.processAnswer(dispatcher, state, answer)
            .then(() => {
                dispatcher({ action: 'closeOverlay', params: 'chooseClaimAppeal' });
            })
            .catch(ex => {
                alert(ex);
            }).finally(() => {
                setStateBusy(false);
            });
    };

    data = data || {};

    return (
        <TSPage name={name}>
            <Slide direction="up" duration="500">
                <div className="container on">

                    <div className="header">
                        <button className="btn right" onClick={handleBack}>
                            <img src="img/right-arrow.svg" alt="back" />
                        </button>
                        <div className="title">רשימת התביעות לערעור</div>
                    </div>

                    <div className="content">
                        <div className="page-content">
                            <div>
                                <h4>יש לבחור בתביעה שעליה רוצים להגיש ערעור</h4>
                            </div>

                            <ClaimSelector claims={data?.["getParentClaims"]} onClaimSelected={handleSelectClaim} />
                        </div>
                    </div>

                    <div className="dialog-buttons">
                        <button className="orange" onClick={handleSubmit}>אישור</button>
                        <button onClick={handleBack}>ביטול</button>
                    </div>
                </div>
            </Slide >
        </TSPage >
    );
}

export { ChooseClaimAppealPage }